import { render, staticRenderFns } from "./replacementRecord.vue?vue&type=template&id=21aceeb4&scoped=true&"
import script from "./replacementRecord.vue?vue&type=script&lang=js&"
export * from "./replacementRecord.vue?vue&type=script&lang=js&"
import style0 from "./replacementRecord.vue?vue&type=style&index=0&id=21aceeb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aceeb4",
  null
  
)

export default component.exports